module.exports = __webpack_public_path__ + "./img/sold.bab932c07a47931a31174234cb3ed12b.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/sold.png
// module id = ./src/containers/Briefcase/entry/icons/sold.png
// module chunks = 0